import { HiShieldCheck } from "react-icons/hi";
import { MdCancel, MdAnalytics } from "react-icons/md";
const data = [
  {
    icon: <HiShieldCheck/>,
    heading: "Beauty of Small Things",
    detail:(
        <>
        <p className='description'>
                  "I’ll be happy when I get into my dream college"
                  "I’ll be happy when I get a good job"
                  "I’ll be happy once I settle down"
                  "Why am I so unhappy right now?"
                </p>
                <p className='description'>
                  When you grow up constantly having the voice in your head telling you that you need to prove yourself, you forget to be human for a moment. You embody all the identities that are labeled onto you except for your own name. The unfamiliarity on hearing something supposedly familiar can lead to a sense of detachment. Which is why every once in a while you need to remind yourself that you are real. And that you are human. And that can only come with the little things in life.
                </p>
                <p className='description'>
                  When you notice a dog crossing the street or a bird flying in the sky
                  When you see a couple on a bench and wonder when will it be your time
                  When you go through old photo albums and see the home you left behind
                  When you eat an apple alone in your room and try to stop yourself from crying
                  But it’s important to let out your feeling every once in a while
                  You are only human, you are bound to get tired
                </p>
                <p className='description'>
                  All of us want to watch our life’s movie without having bloopers and deleted scenes in it. We want a picture-perfect story painted in front of our eyes but forget to notice the smaller details- the small joys and sacrifices that we made along the way to get where we are right now. Life is like a jigsaw puzzle, only when you see the beauty of the individual pieces, will you find satisfaction when you complete the entire picture.
                </p>
                <p className='description'>
                  When we are younger, we are born with an innate sense of righteousness. We see things as black and white because most of our thinking is grounded in observation. Slowly, as we grow up, we realize that it’s much more than the simple binary we were introduced to.
                  Life is not black and white, it is colorful - colors you hate, colors you like, colors you didn’t know existed. And you can define the hue and saturation for each color. You can make it brighter or switch to another color altogether but you can’t expect the colors to disappear.
                  Let yourself time travel to relive some of the dear instants as the blog takes you on a voyage of moments that have been the calm to your turmoil.
                </p>
        </>),
  },
  {
    icon: <MdCancel />,
    heading: "THE Festival Story",
    detail:(<>
    <p className='description'>Some say that they dawn on their unassuming, unaware souls the way the early morning rays of the sun fondle the flowers, silent, soft yet purposeful. Others argue that the spirit of these special guests never really leave their body; that as soon as the winds change, so do their hearts, dancing with anticipation, to take on the moments to come. </p>

<p className='description'>But for me, the festival season, that is, the August-November block, has always been a personal favorite. 
The season, the weather, the almost feveric craze of 'saaf-safai', accompanied by tonnes of gifts-shopping, mithai-making, plotting, planning, navigation through copious amounts of charts to decide which relative to visit first and who </p>

<p className='description'>Last, the routinely doses of decoration, one could go on and on about this festival fever; it's that infectious!</p>

<p className='description'>But there are sides to it that have changed too, evolved through slow but robust processes of growth, which haven't always been onwards and upwards. What follows next is a discussion on just some of these aspects:-</p>

<p className='description'>"But, video call hi kar lete hai na!"</p>

<p className='description'>That had been my sister's mantra last Diwali, whenever our mother would ask her to get ready for the traditional Diwali Blessings Exchange (yup, we call them that, for they always come in pairs, us followed by them or maybe sometimes the other way round?). The reason? "Ghar chodke kyu jaana? Why the formality?" She argued, jaw firm with determination. (and what followed was a typical Indian family dharmayuddha, but you must have already guessed that by now!) </p>

<p className='description'>But, how did this happen?</p>

<p className='description'>More than three thousand years ago, when Dwapar Yug ended, a new era began; of shortcuts and revolutions, innovations and mechanisations and, quite unfortunately, of procrastinations and lost connections.</p>
<p className='description'>Today is the age of video calls over visits, of whatsapp chatting over the usual chai-wala "what's up?". Of home-stays over "chalo mile!"</p>
<p className='description'>The issue? The pandemic era, or rather the shut-in time, somewhere boosted a process of isolation and distance that had begun much earlier. As TV commercials and music videos began to 'normalize'
</p> 

<p className='description'>staying inside and not interacting, 'the new normal' set in. Digitalisation spread faster then wildfire. OTT replaced movies and Hardcovers E-Books. No one wanted to leave their safety zones and dine-out anymore; why do it when we have take out? The counters were many. And there to stay. </p>

<p className='description'>Soon, festivals were restricted to the four walls of the house. Digital blessing began to pour in. Why even call, when one had the alternative of choosing from so many cute blessing stickers? </p>

<p className='description'>The end result today, stands in front of us as a living testimony to what we have lost, just some pictures and videos of what had once constituted a full-blown Diwali family lunch, with children bent over their favorite board games in their bedrooms and adults </p>

<p className='description'>gossiping outside, foods and drinks all around. And they too have begun to fade.
What do we do then? Start clicking new memories or let them stay lost in the old, dusty ones?</p>

<p className='description'>The Unrepresented story</p>

<p className='description'>Diwali, a time when cities and towns across India transform into a visual symphony of illumination, simultaneously illuminates the binary that has become deeply embedded in the celebration. At its core, Diwali represents the triumph of light over darkness, good over evil, and knowledge over ignorance. This symbolic play of binaries, derived from ancient Hindu myths, is something that lies at the core of the festival. And what lies at the core of this article is also binaries, just not the symbolic ones.</p>


<p className='description'>Imagine, for a moment, the bustling markets during Diwali. Shopfronts, adorned with colorful rangoli designs, invite passersby with their enchanting displays of diyas, twinkling fairy lights, and an array of festive decorations. The vivid colours of lights and decorations, fragrant aromas of the sweets being sold nearby, the hum of spirited conversations and the shrieks of the vendors- all these are unique to the festive market in India. These markets are flocked by people throughout the entire day. You’ll find people examining and comparing products in all the shops to make the best purchase at the best price.</p>

<p className='description'>But what often gets overlooked are the shopkeepers, who, too, have a family, sacrificing which they put up the shops. Diwali, to us, is about celebrating with our</p>

<p className='description'>loved ones; to them, it is about earning that extra buck, failing which they may run the risk of remaining unfed in the days ahead when there is a slump in the market. Their eyes gleam when they are able to actualise some surplus, which they’d more often choose to spend on their kids, just to ensure that they too get their own share of joy during the grand festival. On the day of the festival itself, their shops remain open till late at night. The last piece of cracker that they sell is not the last piece that they possess, for they have kept aside some for their family, to whom they’ve promised to return on time.</p>




<p className='description'>A festival, dear readers, is not the same for everyone. Diwali, for example, is a mosaic of experiences, each holding its unique place. For some, Diwali is a time of spiritual reflection and worship. Families gather in their homes to perform elaborate rituals, light oil lamps or diyas, offer prayers to the deities, and exchange blessings and sweets. For some others, Diwali represents an opportunity to make ends meet, secure their livelihoods, and ensure a brighter future for their families. Their experience is one of hard work, dedication, and sacrifice. They may not have the luxury of participating in the festivities as others do, but their efforts contribute to the vibrancy and buoyancy of the festival. So, remember, the next time, you celebrate a festival; its beauty lies in its multiplicity, encompassing countless stories, emotions, and traditions.</p>
    </>),
      
  },
  {
    icon: <MdAnalytics />,
    heading: "Money",
    detail:(<>
        <p>
        There are money-life meditations, negative and positive, which I can do.
      </p>

      <p>
        D.H. Lawrence (1885-1930), famous for writing novels about sex, was perhaps a reincarnation of the great William Shakespeare. I did not know since long that he had penned a great poem meditating on money-life connect, like this:
      </p>

      <p>
        Money is our madness, our vast collective madness.
      </p>

      <p>
        And of course, if the multitude is mad
      </p>

      <p>
        the individual carries his own grain of insanity around with him.
      </p>

      <p>
        I doubt if any man living hands out a pound note with-out a pang;
      </p>

      <p>
        and a real tremor, if he hands out a ten-pound note.
      </p>

      <p>
        We quail, money makes us quail.
      </p>

      <p>
        It has got us down, we grovel before it in strange terror.
      </p>

      <p>
        And no wonder, for money has a fearful cruel power among men.
      </p>

      <p>
        But it is not money we are so terrified of, it is the collective money-madness of mankind. For mankind says with one voice: How much is he worth? Has he no money? Then let him eat dirt, and go cold.– And if I have no money, they will give me a little bread so I do not die, but they will make me eat dirt with it. I shall have to eat dirt, I shall have to eat dirt if I have no money. It is that that I am frightened of. And that fear can become a delirium. It is fear of my money-mad fellow-men.
      </p>

      {/* ... Add more paragraphs as needed */}

      <p>
        When I meditate on this poem and these films, I am unable to overcome my existential angst about lacking money. Moreover, I am only aware that there is a devil in me taking me faster towards loot, murder, infidelity and my own death. I have an unquenchable desire for wealth. I have the propensity to fall prey to the attraction of money because of my relentless quest for financial gain by hook or crook. I bow to the evils of materialism and the risks of losing sight of what matters most in life. I am not cognizant of the inherent emptiness of a life lived only to accumulate wealth, and of the potential repercussions of abandoning healthy inter-personal relationships, moral principles and emotional well-being in the name of monetary achievement.
      </p>

      <p>
        By contrast, Irani (2014) is an amazing book, which confidently promises that “everyone” in this world can obtain financial freedom without having to sell one’s soul to the devil! “People see lack of money as a problem and believe that having lots of money is the way to overcome it. However, money is not the problem. The problem is lack of knowledge about money.” “It is the way you deal with money at the time of earning, protecting, budgeting, saving, spending, leveraging, investing and insuring that determines whether money becomes a solution or a problem for you.” “Money is the only thing that is available in abundance in the world today. It is available at the free will of governments, limited only by how fast their printing machines can work…And if the government can print money, so can you, and that too, legally! That is what will take you from financial slavery to financial freedom…Never work for money, but make your money work for you (guaranteed, passive and portfolio income).”
      </p>

      {/* ... Add more paragraphs as needed */}

      <p>
        All I need to do is to meditate and act on the rules of money and life I have never known and heed the associated warnings as conveyed in terms of the following aphorisms:
      </p>

      <p>
        “Making common financial mistakes can destroy your home and impoverish your family.”
      </p>

      <p>
        “Just as a soldier protects his country from all enemy attacks, insurance protects you, your family, assets and business against all kinds of attacks.”
      </p>

      <p>
        “Just as a lion multiplies its chance of making a big kill while hunting in groups, so can you multiply your wealth by unleashing the power of positive leverage.”
      </p>

      <p>
        “While managing your assets, the only thing in your conscious control is asset allocation, which is in fact responsible for 90% of portfolio variability.”
      </p>

      <p>
        “Budget money for the things that you require, otherwise very soon you will be forced to sell the things that you need.”
      </p>

      <p>
        “You should be investing in speculative items but overdoing it will leave you with an investment hangover.”
      </p>

      <p>
        “You can neither hope to create real, sustainable, long-term wealth nor become a successful businessman unless you are a successful equity investor.”
      </p>

      <p>
        “Just as God showers wealth on His devotees, so must the real estate you own put money into your pocket.”
      </p>

      <p>
        “Just as a soldier stands guard outside a fort, so must you guard your life and wealth from predators who legally and systematically rob your money, happiness and life.”
      </p>

      <p>
        “And always bear in mind that to give short-term happiness to your temporary physical body, never do long-term damage to your permanent soul.” This is the most important lesson.
      </p>

      <p>
        Finally, the troublesome point for me to sort out is this: “Those who follow socialist ideas will continue to live a life of scarcity with low wages, higher taxes, money lost to inflation and their wealth stolen by fees and expenses by the very people to whom they entrust their wealth. On the other hand, financially savvy people will live a life of abundance, with governments offering them tax breaks and inflation working in their favor. They will have their own and other people’s money working for them through assets, leverage multiplying their wealth and money running after them.”
      </p>

      <p>
        Be that as it may, according to Mehrab Irani, a parallel education system needs to be set up, wherein “teachers will impart financial knowledge. Instead of teaching youngsters to be workers, teach them to be entrepreneurs; instead of teaching them to avoid risks, teach them to take calculated risks; instead of teaching them to run away from difficulties, teach them to face their difficulties; instead of teaching them to be losers, teach them to be winners; instead of teaching them to be slaves of money, teach them to be masters of money; instead of cursing them with slavery, bless them with financial freedom; instead of teaching them to use their financial wisdom to cheat and deceive the uneducated, encourage them to use it to teach, enlighten and set people free; instead of teaching them to use their financial wisdom to make only themselves richer, goad them to use it to enrich the lives of others.”
      </p>

      <p>
        On a personal note, I have written this piece for all the students who are disappointed and depressed with the subject of economics—whether defined as science of choice or science of wealth— as not a definitive guide to personally becoming rich and happy in this world. These students are perhaps seeking Irani’s insights into financial wisdom and positive meditations on them, “because the problem with today’s youth is that they earn a lot, spend more than they earn, buy liabilities with negative leverage, believing them to be assets, get in a debt trap and then become slaves to money for life.”
      </p>

      <p>
        Note, all the same, that
      </p>

      {/* ... Add more paragraphs as needed */}

      <p>
        And I like to end with this poem:
      </p>

      <p>
        If You Have Money Problems
      </p>

      <p>
        If you have money problems your problems are not small
      </p>

      <p>
        And that money speaks all languages that goes for one and all
      </p>

      <p>
        But that money cannot buy happiness that seems so very true
      </p>

      <p>
        And to the battlers who keep keeping on great credit must be due,
      </p>

      <p>
        There are so many paupers for every millionaire
      </p>

      <p>
        And for millions of people life must seem so unfair
      </p>

      <p>
        It truly is a rat race in the bigger World out there
      </p>

      <p>
        And people with compassion have never been so rare,
      </p>

      <p>
        The poor keep getting poorer whilst the wealthy more wealthy grow
      </p>

      <p>
        And like tis said how one half live the other half would not know
      </p>

      <p>
        And an egalitarian World from us seems far away
      </p>

      <p>
        And even in so-called wealthy Nations poverty is rife today
      </p>

      <p>
        And if you have money problems and are in financial strife
      </p>

      <p>
        Then you are made to struggle with the cross you bear in life.
      </p>

      <p>
        By Francis Duggan, June 2, 2008
      </p>

      <p>
        References
      </p>

      <p>
        <a href="https://poets.org/poet/d-h-lawrence">https://poets.org/poet/d-h-lawrence</a>
      </p>

      <p>
        <a href="https://www.newyorker.com/books/under-review/the-d-h-lawrence-we-forgot">https://www.newyorker.com/books/under-review/the-d-h-lawrence-we-forgot</a>
      </p>

      <p>
        <a href="https://en.wikipedia.org/wiki/Money_Madness_(1948_film)">https://en.wikipedia.org/wiki/Money_Madness_(1948_film)</a>
      </p>

      <p>
        <a href="https://marginalrevolution.com/marginalrevolution/2022/03/will-studying-economics-make-you-rich.htm">https://marginalrevolution.com/marginalrevolution/2022/03/will-studying-economics-make-you-rich.htm</a>
      </p>

      <p>
        By Annavajhula J C Bose, PhD Department of Economics, SRCC
      </p>
    </>),
      
  },
  {
    icon: <MdAnalytics />,
    heading: "Are Inner Demons Real?",
    detail:(<>

<p>
        I am feeling something bad. It is lurking inside me; in fact, it's been there for quite some time. This uncertain feeling, it becomes overpowering sometimes, but it is okay. I can subdue it for now.
      </p>

      <p>
        Tick-tock- tick-tock
      </p>

      <p>
        Oh, it is coming again, this time with more power. My stomach feels quite unpleasant. My chest, it’s feeling heavy. I cannot quite put a finger on this feeling but I am getting distracted by it now.
      </p>

      <p>
        Tick-tock-tick-tock
      </p>

      <p>
        My mind is now filled with these unpleasant thoughts. I cannot stop it now, no matter how much I try. My breathing becomes faster, I cannot focus on any of my work. I am rubbing my chest; my headache is becoming worse as well. My chest hurts, I feel something bitter in my stomach as well. It is like someone is strangling me, taking away all my power to control myself. Someone is saying something but I am snapping at them. Leave me alone, I say. Not to the one who is speaking but to someone who is in there, inside my mind. My eyes start watering leaving me with this feeling of hopelessness. What to do? Where should I go? Why is it happening?
      </p>

      <p>
        Seems quite familiar? For some, maybe not to this extent but for some, maybe even worse than this. But we can all quite agree that we have faced these feelings somewhere out there, whether it's before an important event or maybe because of some specific thing that happened to trigger us only. We describe this situation by many names like breakdown, anxiety, hyperventilation etc. Well, this scenario is just one of the many examples of how these inner voices affect us in our daily life.
      </p>

      <p>
        Do we ever question what are these voices inside our head that become so overwhelming to the point, they leave us broken to this extent? We describe these voices as inner demons. They are not actual beings living inside our mind but the very fabrication of our negative thoughts who bully us at different points of life. They are cynical in nature and pinpoint all the things that can go wrong when we are taking a step in any direction of life. They are blind to positive aspects and just find worse in everyone and everything. Sometimes, they can become our own worst enemy.
      </p>

      <p>
        Ever tried something new? This voice always whispers, it's not worth it, you are not good enough, what’s the use? It's not meant for you? You do not have it in you to complete it.
      </p>

      {/* ... Add more paragraphs as needed */}

      <p>
        The truth is we cannot entirely get rid of these negative thoughts just because we want to; it is a part of our being and it helps in our survival mechanism. There is no straightjacket solution to get rid of inner demons permanently. This is where knowledge comes into play. Knowledge makes us powerful; this fact applies here as well. I am not talking about outer knowledge but the inner one i.e., Self-reflection and Self Discovery. Adopting meditation and spirituality is the key to get to know ourselves better and keep our inner demons at bay as a long-term solution.
      </p>
    </>),
  },
  {
    icon: <MdAnalytics />,
    heading: "K ERAS : The birth of Koreaboos",
    detail:(<>

<p>
        What word best suits defining ‘present’? Complicated? Or rather, we call it enthralling. And what more is that the foresight reveals to be more captivating as it seems that the malleability an individual holds is upright.
      </p>

      <p>
        The present Gen Z generation and the preceding Alpha–beta generation are surely technophile. So we must admit the fact that we are rather looped into the ‘K’ era where K-pop’s names are more familiar than our national patriots, where lyrics from K-pops to drama OST songs are memorized better than our textbook notes, and where people are more intimated towards the K-drama world than the reality we actually live in. Maybe in some ways, it’s what we call Globalization? And it surely did make it to a peak we hesitate to admit.
      </p>

      <p>
        The reality of the ‘K’ era captures a very intriguing corner, and it’s not hard to admit that it makes life a little better and easier in one way or another. Can one deny the fact that K-pop bands from BTS to Black Pink, the K-drams, and the trending fashions of the K-world gave us no room of pleasure and entertainment? Well, for Koreaboos like me… “I simply can’t deny it” because K-pop songs and OSTs played are rather soothing and reasonable in terms of both lyrics and music rhythm. The K-dramas are creative, imaginative, and entertaining. The Korean foods and dress codes are convincing enough for the modern generation of “living through trends”. And this is to test how “Yeppu” K-era is?? Isn’t it?? Trust me; Ramen goes strangely terrific with Kimbap and Kimchi, so much that “You want it for every midnight craving you could have.”
      </p>

      <p>
        You can learn a whole (OST play) of Korean song just by watching that series of K-drama, and you won’t believe that even if you are not a ‘NO DANCER’, the K-pop has its miracles making you do those little quirky dance moves and – it might not only be me. Korea is surely a ‘bucket-list-travel’ to most.
      </p>

      <p>
        Conversely, we also get to see and hear about the toxic environment in Korea due to unrealistic beauty standards with people always trying to look their best. Though looking presentable is justifiable, too much societal pressure has led to many suicidal cases too. And the Korean dating culture of always staying connected to your partners seems to be flawless and romantic; however, always staying close and clingy towards each other can get very exhausting in the long run.
      </p>

      <p>
        All gloomy facts and taboos aside, the K-era: the birth and prosperous growth of Koreaboos is here.
      </p>

      <p>
        By Tenzing
      </p>


    </>),
  },
  {
    icon: <MdAnalytics />,
    heading: "Escaping the MATRIX",
    detail:(<>

<p>
        The 1999 science fiction movie, “The Matrix” was indeed a visual treat! It was a beguiling experience watching a movie that drives us to a fictional dive. A precise context of “The Matrix” would form the foundation of the deep and gaping idea that this piece intends to deliver. It’s a movie where humans are trapped in a simulated reality, a matrix created by intelligent machines. The protagonist, Neo realizes that his reality is a simulated illusion, and the movie is based on how he sets out to escape this illusionary simulation - The Matrix.
      </p>

      <p>
        As of now, you might be bewildered about how the reference of this science fictional-Matrix holds relevance in the paradigms of reality. Well, a simulated matrix doesn’t exist in substantiality but the strings of literature can clasp it in its bosom and give it a deep metaphor worth reading.
      </p>

      <p>
        The matrix metaphorically refers to the pre-existing societal norms, cultural expectations, personal limitations, one’s biased perspectives, or any other constraint or illusion that holds one back! The matrix could be absolutely anything, like why a job is always a nine to five, why pop culture should be the first preference of teenagers, why is it that beauty has a set standard, why there’s an assumption, even unintentional, that everyone is heterosexual, or why career expectations seem to overpower every prospective individual. The expectations are limitless and so the membrane of this so-called matrix gets thicker each day. Escaping this matrix would mean breaking through this matrix and seizing any kind of overpowering stereotype and setting oneself free from the phantom that we tend to build across us and that embraces us so firmly that at a point, the tolerance shackles and this illusion takes our identity. Thus, one needs to escape this matrix to secure one’s individualism.
      </p>

      <p>
        Escaping it may seem like a cakewalk but it’s not so. It is actually when you get to know the truth of your existence; you have to earn the freedom of your life, and this truth is not so easy to digest which is why folks often choose to re-enter the matrix. The foremost challenge to shackle would be self-doubt. When you start questioning your beliefs and your view of the world, you may experience self-doubt and uncertainty. This can be uncomfortable, but it's also an opportunity to explore new perspectives. Another could be resistance from others. As you change and grow, some people in your life may resist or criticize your choices.
      </p>

      <p>
        Escaping the matrix can be a lonely and isolating experience, particularly if your beliefs or actions are not widely accepted by those around you. Finding support from like-minded individuals or communities can help you stay motivated and provide the resources and encouragement you need to keep going.
      </p>

      <p>
        Some of the ideal ways to escape the metaphorical "Matrix" could be to cultivate self-awareness. To escape the "Matrix," you must first recognize that you are in it. This requires cultivating self-awareness and developing a critical perspective on your beliefs about the world. Question everything, especially the things that are presented as "truth" or "reality." Be skeptical and curious about everything. Expand your knowledge by reading, learning, and seeking out diverse perspectives. The more you know, the better equipped you will be to navigate the world outside the "Matrix." You even need to practice mindfulness as it can help you stay present and focused and can also help you develop a greater sense of inner peace. Surround yourself with people who will support and encourage you on your journey outside the "Matrix". You have to be willing to step out of your comfort zone and take risks to achieve your goals. Last but not least; be willing to embrace uncertainty and the unknown. Life is full of surprises, and the more comfortable you are with uncertainty, the better equipped you will be to navigate the challenges and opportunities that come your way.
      </p>

      <p>
        Once you have escaped the matrix, the final challenge is to build a new reality that aligns with your values and beliefs. This may involve creating new relationships, finding new sources of meaning and purpose, and developing new skills and habits that support your new way of life. It can be a challenging and rewarding process that requires patience, perseverance, and a willingness to adapt and learn.
      </p>

      <p>
        Ultimately the key to escaping the matrix is to become more intentional about the choices you make in your life. Wishing you explicit power to escape this matrix because truly, the membrane is thick but so is your determination!
      </p>

      <p>
        By Marisha and Khushee Bhalotia
      </p>
      

    </>),
  },
  {
    icon: <MdAnalytics />,
    heading: "Living a thousand lives : The Power of Reading",
    detail:(<>

<p>
        In a world teeming with mundane routines and humdrum existence, a hidden realm awaits, where the ordinary is shattered, and extraordinary tales come to life. Brace yourself for a thrilling adventure, where the flicker of imagination ignites, and the power to live a thousand lives unfurls before your eyes. Within the pages of books lies an enchanted gateway, beckoning you to embark on a transformative journey like no other. Welcome to a realm where dreams take shape, where the impossible becomes possible, and where the boundless power of reading unfolds.
      </p>

      <p>
        Life is a remarkable journey, filled with endless possibilities and captivating stories waiting to be explored. While we may not have the ability to physically live a thousand lives, the remarkable power of reading allows us to immerse ourselves in countless worlds, experiences, and perspectives. In this blog, we delve into the enchanting realm of literature and explore how reading can transport us to a thousand lives, enrich our understanding of the world, and inspire personal growth.
      </p>

      <h3>The Gateway to Imagination:</h3>
      <p>
        When we open a book, we open the door to a world of imagination. Through the written word, authors have the incredible ability to create vivid landscapes, complex characters, and intricate narratives that can captivate our minds. Whether it's a thrilling adventure, a poignant romance, or a thought-provoking work of non-fiction, reading ignites our imagination and allows us to experience lives beyond our own.
      </p>

      <h3>Empathy and Understanding:</h3>
      <p>
        One of the greatest gifts of reading is its ability to foster empathy and deepen our understanding of others. As we delve into diverse stories and explore different cultures, backgrounds, and experiences, we gain a broader perspective on the world. Literature allows us to walk in the shoes of characters who may be vastly different from us, enabling us to develop empathy, compassion, and a greater appreciation for the human experience.
      </p>

      <h3>Learning from Wisdom:</h3>
      <p>
        Books are reservoirs of knowledge, wisdom, and life lessons. They offer us the opportunity to learn from the experiences of others, both fictional and real. Whether we're reading biographies, historical accounts, or philosophical works, each page holds valuable insights and perspectives that can shape our own lives. By engaging with diverse ideas, we expand our intellectual horizons, challenge our assumptions, and cultivate a thirst for lifelong learning.
      </p>

      <h3>Escaping Reality:</h3>
      <p>
        Sometimes, we all need a temporary escape from the pressures and challenges of everyday life. Reading serves as a respite, transporting us to different worlds and allowing us to disconnect from our reality for a while. It provides solace, relaxation, and the chance to unwind as we lose ourselves in captivating stories, whether it's curled up with a book in a cozy nook or accompanied by the gentle rustling of pages under a tree.
      </p>

      <h3>Inspiration and Personal Growth:</h3>
      <p>
        The power of literature extends beyond entertainment and relaxation. Books can inspire us, spark our creativity, and motivate personal growth. As we follow the journeys of characters, we witness their triumphs, struggles, and personal transformations. Their stories can serve as mirrors reflecting our aspirations, fears, and dreams. Through these literary encounters, we find courage, resilience, and new perspectives that propel us towards self-discovery and personal development.
      </p>

      <h3>Connection and Community:</h3>
      <p>
        Reading not only provides individual enrichment but also creates connections and builds communities. Engaging in book clubs, literary discussions, or online forums allows us to connect with fellow readers, share insights, and engage in meaningful conversations. Books become a shared language, fostering a sense of belonging and the opportunity to form deep connections with people who share our passion for storytelling.
      </p>

      <p>
        Reading is a gateway to a myriad of experiences, allowing us to live a thousand lives within the pages of a book. It broadens our horizons, deepens our empathy, and fuels our personal growth. In a world of limited time, reading offers us the unique opportunity to transcend our lives and embark on countless adventures. So, let us embrace the power of reading, savor the beauty of stories, and allow ourselves to be transformed by the magic that unfolds within the written word.
      </p>

      <p>
        When you read, you put yourself into the shoes of the protagonist, or the antagonist, for that matter. You take a break from your life and enter the imaginary, yet real realm of the character, living his or her life for a change. This develops a valuable character trait in a human being - empathy. It also hones one's ability to lose oneself completely in whatever one is doing, dedicating a hundred per cent to any activity.
      </p>

      <p>
        Living these 'thousand lives' bestow you with knowledge and wisdom like no other experience. It teaches you how to filter the negative influences in life and focus on positivity. It encourages you to stay strong and overcome all obstacles in your path to success. It helps you become a better human being with a vast array of knowledge.
      </p>

      <p>
        "A reader lives a thousand lives before he dies, and the one who doesn't read, lives just one." - George RR Martin
      </p>

      <p>
        By Vyom Gera
      </p>
    </>),
  },

  {
    icon: <MdAnalytics />,
    heading: "Zero Productivity Days",
    detail:(<>

<p>
        "It is not the mountain we conquer, but ourselves." - Sir Edmund Hillary.
      </p>

      <p>
        Getting straight to - what is productivity? Technically speaking, it entails such economic activities that add to the GDP of a country. As for an individual, we call ourselves productive when we tick off all in our to-do list or when our day goes as planned. However, zero productivity or unproductive days seem inevitable today. It's not that it has come into existence in this era. It must have been common earlier too. What makes the difference today is that we give way too much stress on it. "Is it okay to sit back and do nothing?"
      </p>

      <p>
        Why does being unproductive bother us? The foremost reason is - we think we are lagging behind in the rat race. In today's fast-paced world, productivity is often seen as the ultimate measure of success and self-worth. We are constantly bombarded with messages and expectations to be productive every single day. We find ourselves in a loop where the cause and effect are the same, and we remain stranded.
      </p>

      <p>
        Instead of beating ourselves up for these so-called "zero productivity days," it's important to recognize their value and embrace them as an essential part of our well-being. We need to know how we can make the most of them to foster self-acceptance and personal renewal. The best way to deal with this is through introspection. Ask yourself why I do not feel like doing what I planned for the day. It so happens that we have a lot piled up but still we feel like skipping everything. Well, introspection will help you realize what's bothering you. There must be something that's holding you back. And it's okay to be held back for a while. Don't stress too much or force yourself. Do what makes you happy. Eat good food, listen to good music, watch your favorite movie, talk to your best friend, talk to your family, maybe try writing anything, try cooking, painting, whatsoever can cheer you up. Don't rigorously tell yourself every minute that you are being unproductive. That will push you into yet another unproductive day.
      </p>

      <p>
        What we often mistakenly do is blaming ourselves for being unproductive. Instead, we need to justify ourselves. That will motivate us. We need to extend our helping hands towards ourselves. Plan for the next day. Since you took that step for you today, you would be a better version of yourself the next day. Zero productivity days are not a reflection of failure or inadequacy; they are a natural part of our human experience.
      </p>

      <p>
        By accepting and embracing these days, we can nurture our well-being, recharge our energy, and gain valuable insights into our lives. Let's strive for a balanced approach, where productivity and self-care coexist harmoniously, allowing us to lead more fulfilling and authentic lives. Remember, self-acceptance and personal renewal are the true measures of success, not the number of tasks crossed off our to-do lists.
      </p>

      <p>
        "Both good and bad days should end with productivity. Your mood affairs should never influence your work." - Greg Evans.
      </p>

      <p>
        You did emerge productive by counterattacking your unproductivity.
      </p>

      <p>
        By Khushee Bhalotia
      </p>
    </>),
  },
  {
    icon: <MdAnalytics />,
    heading: "Arrival of Spring",
    detail:(<>

<p>
        “Spring is when you feel like whistling, even with a shoe full of slush.”
      </p>

      <p>
        - Doug Larson
      </p>

      <p>
        The spirit of spring is full of warmth and positivity that shakes us out of our melancholy and fills us with renewed energy. All that one needs is a stroll in the park or a look out of the window. After a long blue winter, our hearts blossom with new hope for a better future.
      </p>

      <p>
        The sigil of freshness brings to us fistfuls of potentials, urging us to seize moments that come our way. This is not only a season that brings joy but also the embryo of an empowering epoch meant to enrich, enlighten, and earn us experience. The magic of new beginnings and the solace of starting afresh fill our beings with immense power, harnessed watt by watt to achieve our wildest dreams.
      </p>

      <p>
        The arrival of spring is as promising to an individual as the joy a seedling holds when it finally grows into a plant - hopeful of newer developments and growth in the future. Frank Sinatra has beautifully sealed this heartwarming promise in his lyrics, “Fly me to the moon, let me play among the stars, let me see what spring is like!” which is a testimony to the sheer joy spring brings to the world.
      </p>

      <p>
        A source of inspiration for tons of folks across the globe, spring never skips a turn. Since time immemorial, writers have loved spring, as much as they have loved in spring. With the smatter of low-lying clouds dotting the sky, sunshine warming up our souls, and the chitter-chatter of birds adding melody to the air, how can one not fall in love?
      </p>

      <p>
        Writing is a powerful art to master, but when people reach a certain level, they frequently forget that "with great power comes great responsibility." What we read can influence us in unimaginable ways and it stays with us for an indefinite period of time. It is only a 7-letter word, yet it holds the power to warm the world in a heartbeat or harm it in a heartbreak.
      </p>

      <p>
        William Blake and John Keats are two romantics who have made sure to transport the readers into an alternate world by their work. Nonetheless, writing brings both the writer and the reader a sense of calm and happiness. It serves as an escape button from reality at times and forces you to confront it at others. Both the reader and the author get enthralled by a connection that only they can forge or sever. It's simply too nice to live through other people's thoughts and comprehend them via their writing; it's like spring following a lovely winter.
      </p>

      <p>
        Similar to how springtime has such a smooth transition from one season to the next that it becomes impossible to tell them apart, every chapter or page of this book offers a fresh glimmer of optimism. Flowers grow, yet all we can see are lush green spaces and foliage everywhere. This shows us that a deity created such a stunningly lovely planet!
      </p>

      <p>
        A writer also pours his heart and soul into producing a work of art for the reader; they also nourish their writing, which grows unpredictably and leads readers onto a vivid trip filled with unending beauty.
      </p>

      <p>
        The moment we want to write about and explain what is in front of us, writing enters the picture. When we see spring flowers from a distance, we see such a sight that appears too wonderful to be true, or in this instance, too beautiful to be real. We must experience a specific emotion to write about it. We actually create art with it by using our sheet of paper as a canvas, our pen as a paintbrush, and our ingenuity as the color. A writer writes from the heart in black and white on a sheet of paper yet it feels as colorful as the colors spring bestows upon us!
      </p>

    </>),
  },
  {
    icon: <MdAnalytics />,
    heading: "Buzz to taking Breaths",
    detail:(<>

<p>
        “Nobody can hurt me without my permission.” - Mahatma Gandhi
      </p>

      <p>
        The buzz starts with the ringing of the alarm, engulfing breakfast, running even on the accelerator, eternal seeming lectures and ends with setting another alarm. Indeed, life is not a bed of roses and here lies the realization.
      </p>

      <p>
        Being a college student is not easy. I’m still looking for the people who used to say college life is fun, still searching for joy, still learning the metro routes, still learning the turns of the way to college, and still sitting in the corner again thinking where is the fun? The current scenario of traveling, internal assessments, and exams only adds to the stress and pressure that students already face.
      </p>

      <p>
        This hectic schedule often leads to a culture of hustle, competition, and constant pressure to perform, which can have a severe impact on students' mental health. The hustle culture, often glorified in society, promotes the idea that one needs to work hard and continuously in order to achieve success. While hard work is essential, the culture of hustle often leads to burnout, exhaustion, and mental health issues.
      </p>

      <p>
        Does all this stress me out? Should I admit this? Would getting admission to an average college in my town have been a better decision? Why am I pissed off? Do I need more time? But is this the right way to let things remain?
      </p>

      <p>
        It's important for students to understand that success does not come at the cost of their well-being. Competition among students can also lead to stress and pressure. Students may feel like they constantly need to outdo their peers, which can be exhausting and unhealthy. It's important for students to focus on their own growth and development, rather than constantly comparing themselves to others.
      </p>

      <p>
        Depression is not inherited, it is acquired. Self-doubt is not a characteristic, it is a habit. A psychiatrist is not a medical person; he is now a normal being whom you encounter every day. You are not an introvert, just an alone fellow for now.
      </p>

      <h2>How to handle stress?</h2>

      <ul>
        <li>Dealing with a hectic schedule requires proper time management and self-care.</li>
        <li>Students should prioritize their tasks and allocate time for studying, traveling, and other activities.</li>
        <li>They should also make time for relaxation, exercise, and socializing to ensure a balanced lifestyle. For students, yoga and meditation have proved to be a boon.</li>
        <li>Seeking help when needed is crucial for maintaining good mental health.</li>
        <li>Students can reach out to counselors, professors, or support groups for guidance and assistance. It's important to remember that it's okay to ask for help.</li>
        <li>Give yourself a proper royal pampering which you actually deserve on the weekends.</li>
        <li>You have to learn to snatch time for yourself, be busy with your inner self and have self-introspection. Never stop questioning yourself - why you are doing so? What will you get from it? Is it really worth spending your time on?</li>
        <li>Last but not least, when you can't think of any way, just close your eyes, take deep breaths and rush to your parents. Sharing has been termed a medicine for the disease called stress. If you can't think of any way to come out of the messy routine, your parents will surely take you out of the pit.</li>
      </ul>

      <p>
        In conclusion, the hectic schedule of students can be overwhelming and stressful. It's important for students to prioritize their well-being and focus on their personal growth rather than constantly comparing themselves to others. Time management, sharing your thoughts with others, and self-care are crucial for dealing with a busy schedule, and seeking help when needed is essential for maintaining good health and well-being.
      </p>

      <p>
        Whenever you feel stressed out, always remember that nothing is more important in this world than you.
      </p>

    
        
    </>),

  },
];
export default data;